import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditWorkCenter() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState({
    name: "",
    capacity_per_day: ""
  });

  useEffect(() => {
    fetchWorkCenter();
  }, []);

  // Fetch WorkCenter details
  const fetchWorkCenter = () => {
    axios.get(baseUrl + "workcenters/" + id + "/")
      .then(res => {
        setData({
          name: res.data.name || "",
          capacity_per_day: res.data.capacity_per_day || ""
        });
      })
      .catch(() => Swal.fire("Error", "Could not fetch Work Center", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    if (!data.name || data.capacity_per_day === "") {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("name", data.name);
    _formData.append("capacity_per_day", data.capacity_per_day);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "workcenters/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(response => {
        if (response.status === 200) {
          Swal.fire({
            title: "Work Center Updated",
            icon: "success",
            timer: 2000,
            showConfirmButton: false
          });

          setTimeout(() => {
            navigate("/work-centers/");
          }, 2000);
        }
      })
      .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Work Center</h4>

        <input
          type="text"
          className="form-control mt-3"
          name="name"
          value={data.name}
          onChange={inputHandler}
          placeholder="Work Center Name"
        />

        <input
          type="number"
          className="form-control mt-3"
          name="capacity_per_day"
          value={data.capacity_per_day}
          onChange={inputHandler}
          placeholder="Capacity per Day"
        />

        <button className="btn btn-primary mt-3" onClick={formSubmit}>
          Update
        </button>

      </div>
    </div>
  );
}

export default EditWorkCenter;
